module.exports = __webpack_public_path__ + "static/media/rsz_massan-001.4d517e72.jpg";